import React, { forwardRef } from 'react';

import { cn } from 'common/style/utils';

const Flex = forwardRef<HTMLDivElement, React.ComponentProps<'div'>>(
  ({ children, className, ...props }, ref) => {
    return (
      <div ref={ref} className={cn('flex', className)} {...props}>
        {children}
      </div>
    );
  },
);

export default Flex;
